// extracted by mini-css-extract-plugin
export default {"genreTags":"I3LZ_"};